<template>
  <div class="withdraw-management-page">
    <!-- 顶部标题与搜索 -->
    <div class="page-header" style="display: flex; align-items: center; margin-bottom: 20px;">
      <h2 style="font-size: 20px; font-weight: 600; margin-right: 20px;">提现管理</h2>
      <el-input
        v-model="keyword"
        placeholder="搜索商户名称、账户..."
        style="width: 300px;"
        @keyup.enter.native="handleSearch"
      ></el-input>
    </div>

    <!-- 分页列表 -->
    <el-table :data="withdrawList" border stripe>
      <el-table-column prop="shopName" label="商户名称" width="160"></el-table-column>
      <el-table-column prop="bankName" label="开户行" width="130"></el-table-column>
      <el-table-column prop="bankCardNum" label="账户" width="170"></el-table-column>
      <el-table-column prop="type" label="款项类型" width="110"></el-table-column>
      <el-table-column prop="amount" label="提现金额" width="120">
        <template slot-scope="scope">¥{{ scope.row.amount | currency }}</template>
      </el-table-column>
      <!-- <el-table-column prop="fee" label="服务费" width="120">
        <template slot-scope="scope">¥{{ scope.row.fee | currency }}</template>
      </el-table-column> -->
      <el-table-column prop="createTime" label ="提现时间" width="170"></el-table-column>
      <el-table-column label="打款时间" width="110">
        <template slot-scope="scope">
          <!-- 当打款时间存在时显示时间，否则显示状态名称 -->
          <span v-if="scope.row.remitTime">{{ scope.row.remitTime }}</span>
          <span v-else>{{ scope.row.statusName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="viewDetail(scope.row)">查看</el-button>
          <el-button
            type="success"
            size="small"
            v-if="scope.row.status === 0"
            @click="showPaymentConfirmDialog(scope.row)"
          >
            打款完成
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="提现详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      center
    >
      <el-form label-width="100%" label-position="top">  <!-- 标签置于值上方 -->
        <!-- 第一行：商户名称 + 统一社会信用代码 -->
        <el-row gutter="20">  <!-- 列间距20px -->
          <el-col span="12">  <!-- 每列占12/24宽度 -->
            <el-form-item label="商户名称" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentDetail.shopName }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="统一社会信用代码" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentDetail.socialCreditId }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：开户行 + 账户 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="开户行" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133; margin-top: 5px;">{{ currentDetail.bankName }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="账户" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133; margin-top: 5px;">{{ currentDetail.bankCardNum }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行：款项类型 + 提现金额 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="款项类型" style="text-align: center; padding: 10px;">
              <div style="font-size: 16px; color: #303133;">{{ currentDetail.type }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="提现金额" style="text-align: center; padding: 10px;">
              <div style="font-size: 16px; color: red;">¥{{ currentDetail.amount | currency }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行：服务费 + 提现时间 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="服务费" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">¥{{ currentDetail.fee | currency }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="提现时间" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentDetail.createTime }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="20">
          <el-col span="12">  <!-- 占满24列 -->
            <el-form-item label="打款时间" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">
                {{ currentDetail.remitTime || currentDetail.statusName }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 打款完成确认弹窗 -->
    <el-dialog
      title="提现详情"
      :visible.sync="confirmPaymentDialogVisible"
      width="600px"
      center
    >
    <el-form label-width="100%" label-position="top">  <!-- 标签置于值上方 -->
        <!-- 第一行：商户名称 + 统一社会信用代码 -->
        <el-row gutter="20">  <!-- 列间距20px -->
          <el-col span="12">  <!-- 每列占12/24宽度 -->
            <el-form-item label="商户名称" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentPaymentDetail.shopName }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="统一社会信用代码" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentPaymentDetail.socialCreditId }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：开户行 + 账户 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="开户行" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133; margin-top: 5px;">{{ currentPaymentDetail.bankName }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="账户" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133; margin-top: 5px;">{{ currentPaymentDetail.bankCardNum }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行：款项类型 + 提现金额 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="款项类型" style="text-align: center; padding: 10px;">
              <div style="font-size: 16px; color: #303133;">{{ currentPaymentDetail.type }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="提现金额" style="text-align: center; padding: 10px;">
              <div style="font-size: 16px; color: red;">¥{{ currentPaymentDetail.amount | currency }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行：服务费 + 提现时间 -->
        <el-row gutter="20">
          <el-col span="12">
            <el-form-item label="服务费" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">¥{{ currentPaymentDetail.fee | currency }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="提现时间" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">{{ currentPaymentDetail.createTime }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="20">
          <el-col span="12">  <!-- 占满24列 -->
            <el-form-item label="打款时间" style="text-align: center; padding: 2px;">
              <div style="font-size: 16px; color: #303133;">
                {{ currentPaymentDetail.remitTime || currentPaymentDetail.statusName }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmPaymentDialogVisible = false">取消</el-button>
        <el-button type="success" @click="confirmPaymentSubmit">确认完成</el-button>
      </div>
    </el-dialog>

    <el-pagination
      style="margin-top: 20px;"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      @current-change="handlePageChange"
      background
    ></el-pagination>
  </div>
</template>

<script>
import { getWithdrawApplyList,
  getWithdrawApplyDetail,
  withdrawApplyConfirm
 } from '@/api/fund'; // 假设的接口文件路径
import { formatCurrency } from '@/utils/format'; // 货币格式化工具

export default {
  data() {
    return {
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      withdrawList: [],
      detailDialogVisible: false,  // 新增：详情弹窗显示控制
      currentDetail: {},  // 新增：存储当前查看的详情数据
      confirmPaymentDialogVisible: false,  // 新增：打款确认弹窗控制
      currentPaymentDetail: {}  // 新增：存储当前打款的详情数据
    };
  },
  filters: {
    currency(value) {
      return formatCurrency(value);
    }
  },
  created() {
    this.fetchWithdrawList();
  },
  methods: {
    // 获取列表数据
    async fetchWithdrawList() {
      try {
        const res = await getWithdrawApplyList({
          keyword: this.keyword,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        if (res.code == 0) {
          this.withdrawList = res.data.records;
          this.total = Number(res.data.total);
        } else {
          this.$message.error(res.msg);
        }

      } catch (error) {
        console.error('获取提现列表失败:', error);
      }
    },

    // 搜索处理
    handleSearch() {
      this.pageNum = 1;
      this.fetchWithdrawList();
    },

    // 分页变化
    handlePageChange(page) {
      this.pageNum = page;
      this.fetchWithdrawList();
    },

    // 查看详情
    async viewDetail(row) {
      let res = await getWithdrawApplyDetail({ id: row.id });
      if (res.code == 0) {
        this.currentDetail = res.data;  // 保存当前行数据
        this.detailDialogVisible = true;  // 显示弹窗
      } else {
        this.$message.error(res.msg);
      }

    },

    // 显示打款确认弹窗
    async showPaymentConfirmDialog(row) {
      let res = await getWithdrawApplyDetail({ id: row.id });
      if (res.code == 0) {
        this.currentPaymentDetail = res.data;  // 保存当前行数据
        this.confirmPaymentDialogVisible = true;  // 显示弹窗
      } else {
        this.$message.error(res.msg);
      }
    },

    // 确认打款完成
    async confirmPaymentSubmit() {
      if (!this.currentPaymentDetail.id) return;
      try {
        const res = await withdrawApplyConfirm({ id: this.currentPaymentDetail.id });
        if (res.code === 0) {
          this.$message.success('打款完成');
          this.confirmPaymentDialogVisible = false;  // 关闭弹窗
          this.fetchWithdrawList();  // 刷新列表
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.error('打款完成失败:', error);
      }
    },
  }
};
</script>

<style scoped>
/* 可选样式调整 */
.withdraw-management-page {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 40px);
}
</style>

    <!-- 打款完成确认弹窗 -->
    <el-dialog
      title="确认打款完成"
      :visible.sync="confirmPaymentDialogVisible"
      width="500px"
      center
    >
      <el-form label-width="120px" label-position="top">
        <el-form-item label="商户名称">
          {{ currentPaymentDetail.shopName }}
        </el-form-item>
        <el-form-item label="提现金额">
          ¥{{ currentPaymentDetail.amount | currency }}
        </el-form-item>
        <el-form-item label="当前状态">
          {{ currentPaymentDetail.statusName }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmPaymentDialogVisible = false">取消</el-button>
        <el-button type="success" @click="confirmPaymentSubmit">确认完成</el-button>
      </div>
    </el-dialog>
